import React from "react";
import { BsQuestionDiamondFill } from "react-icons/bs";
import { useParams } from "react-router-dom";

export default function FAQ() {
  const { id } = useParams();
  const faqList = [
    {
      id: "1",
      idd: "d1",
      "aria-expanded": "false",
      question: "My scores are not updated in CP TRACKER?",
      answer: "Check if you have filled the correct handles in the coding profile page. After attempting the problem or contest, wait for 24 hours. Mentorpick crawls the data of each user once every 24 hours.",
    },
    {
      id: "2",
      idd: "d2",
      "aria-expanded": "false",
      question: "I attempted Leetcode/Codechef contest yesterday, but my scores are not updated yet in CP TRACKER?",
      answer: "Check if the scores are updated on the original site or not. Leetcode generally updates the contest attempted count after 5 days.",
    },
    {
      id: "3",
      idd: "d3",
      "aria-expanded": "false",
      question: "My scores are not updated on Leetcode, Codechef, Codeforces... etc.",
      answer: "The above sites are not controlled by Being Zero.",
    },
    {
      id: "4",
      idd: "d4",
      "aria-expanded": "false",
      question: "Despite my usernames being correctly updated, my score in CP TRACKER is not updated?",
      answer: "It can be due to: 1. You have solved or attempted a problem within the last 24 hours. 2. Data might not be updated on the original site. 3. The original site is down.",
    },
    {
      id: "5",
      idd: "d5",
      "aria-expanded": "false",
      question: "Please update my score in CP TRACKER?",
      answer: "Wait for a day, and your score should be updated automatically. We do not update the score of any individuals manually.",
    },
    {
      id: "6",
      idd: "d6",
      "aria-expanded": "false",
      question: "Unable to update my handles. What should I do?",
      answer: "Contact the Being Zero team members.",
    },
  ];


  return (


    <div className="container">
      <h2 className="my-5">Frequently Asked Questions</h2>
      <div className="accordion" id="accordionExample">
        {faqList.map((faq, index) => {
          return (
            <div className="accordion-item" key={index}>
              <h2 className="accordion-header" id={faq.id}>
                <button
                  className="accordion-button "
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${faq.idd}`}
                  aria-expanded={faq.aria_expanded == "true" ? "true" : "false"}
                  aria-controls={`${faq.idd}`}
                >
                 <BsQuestionDiamondFill/>&nbsp;  {faq.question}
                </button>
              </h2>
              <div
                id={faq.idd}
                className={`accordion-collapse collapse ${
                    id == faq.id ? "show" : ""
                }`}
                aria-labelledby={faq.idd}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body px-4 "> {faq.answer}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
